import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import PaletteProvider from 'contexts/PaletteProvider'
import BookmarkButton from 'tripPlanner/components/Bookmark/BookmarkButton'
import TripGuard from 'tripPlanner/components/TripGuard/TripGuard'
import React from 'react'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import HeroCruiseOfferTilePricing from '../Support/HeroCruiseOfferTilePricing'
import { HeroCruiseLocation } from './components/HeroCruiseLocation'
import { HeroCruiseItinerary } from './components/HeroCruiseItinerary'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import VerticalContainerWithFadedOverflow from 'components/Common/VerticalContainerWithFadedOverflow'

const DetailContainer = styled(Pane)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: ${rem(16)};

  ${mediaQueryUp.md} {
    flex: 1;
    padding:  ${rem(16)} ${rem(32)} ${rem(32)};
  }
`

const FixedHeightGroup = styled(Group)`
  height: ${rem(212)};
`

interface Props {
  isDesktop: boolean;
  offer: App.CruiseOffer;
}

function HeroCruiseOfferDetails({ isDesktop, offer }: Props) {
  const { duration, itinerary, ship } = offer
  const shipInfoDescription = ship.shipInfo?.find(info => info.dataTypeName === 'Summary')?.description
  const cruiseDescription = offer?.description || shipInfoDescription || offer.destinationDescription

  const parsedDescription = (cruiseDescription || '')
    .replace(/(<([^>]+)>)/gi, '')
    .split(' ')
    .slice(0, 10)
    .join(' ') + '...'

  return (
    <PaletteProvider type={isDesktop ? 'default' : 'inverse'}>
      <DetailContainer>
        <TripGuard>
          {isDesktop && (
            <Group direction="horizontal-reverse">
              <BookmarkButton offer={offer} />
            </Group>
          )}
        </TripGuard>
        <Group direction="vertical" verticalAlign="space-between" fullHeight>
          <VerticalContainerWithFadedOverflow>
            <FixedHeightGroup direction="vertical" gap={4}>
              <HeroCruiseLocation offer={offer} />
              <Group direction="vertical">
                <Heading variant="heading5" lineClamp={2} colour="neutral-one">{offer.name}</Heading>
                {parsedDescription && (
                  <MarkdownRender
                  type="compact"
                  fontSize="small"
                  fontWeight="normal"
                  content={parsedDescription}
                />
                )}
              </Group>
              <BodyText variant="medium" colour="neutral-two">
                {offer.cruiseLine.name} · {offer.ship.name}
              </BodyText>
              {itinerary && <HeroCruiseItinerary duration={duration} itinerary={itinerary}/>}
            </FixedHeightGroup>
          </VerticalContainerWithFadedOverflow>
          <HeroCruiseOfferTilePricing offer={offer}/>
        </Group>
      </DetailContainer>
    </PaletteProvider>
  )
}

export default HeroCruiseOfferDetails
